import { adminHttpClient } from '../../../../commons/adminHttpClient'

const ichraClassSelection = (planPeriodId: string): Promise<string> => {
  return adminHttpClient.post(`AdminDashboard/ichra/ClassSelection/${planPeriodId}`, {})
}

export default ichraClassSelection
